import type * as React from 'react';

export const Icon48DoneOutline = (props: React.SVGProps<SVGSVGElement>): React.ReactNode => (
  <svg
    className="vkuiIcon"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 24L19 34L39 14"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
